import ElectronicKeyTypes from 'store/actionTypes/electronicKey'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  systems: [],
  current: {},
  pagination: {},
  filter: {},
  vehicleList: [],
  vehiclePagination: [],
  vehicleFilter: {}
}

const electronicKey = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case ElectronicKeyTypes.GET_ELECTRONIC_KEYS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case ElectronicKeyTypes.GET_ELECTRONIC_KEY_DETAIL_SUCCESS:
      return { ...state, current: payload }
    case ElectronicKeyTypes.UPDATE_FILTER_ELECTRONIC_KEY_SUCCESS:
      return { ...state, filter: payload }
    case ElectronicKeyTypes.CLEAR_FILTER_ELECTRONIC_KEY_SUCCESS:
      return { ...state, filter: initialData.filter }
    case ElectronicKeyTypes.GET_SHEET_VEHICLE_ELECTRONIC_KEYS_SUCCESS:
      return {
        ...state,
        vehicleList: payload?.items,
        vehiclePagination: payload?.meta
      }
    case ElectronicKeyTypes.UPDATE_FILTER_VEHICLE_ELECTRONIC_KEY_SUCCESS:
      return { ...state, vehicleFilter: payload }
    case ElectronicKeyTypes.CLEAR_FILTER_VEHICLE_ELECTRONIC_KEY_SUCCESS:
      return { ...state, vehicleFilter: initialData.filter }
    case ElectronicKeyTypes.GET_SYSTEM_ELECTRONIC_KEYS_SUCCESS:
      return { ...state, systems: payload?.electronicKey?.items }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default electronicKey
